import {
  add,
  addYears,
  format,
  getMonth,
  getYear,
  parseISO,
  subYears,
  setMonth,
} from "date-fns";
import React, { useEffect } from "react";
import { useState } from "react";
import ptBR from "date-fns/locale/pt-BR";
import {
  Dropdown,
  DropdownButton,
  DropdownContent,
  DropdownItem,
} from "../../styles-components/Dropdown";
import { apiPedidos } from "../../services/data";
import LoadingEffect from "../../components/LoadingEffect";
import { ContainerCard } from "../../styles-components/Container";
import { Table } from "../../styles-components/Table";
import {
  ButtonA,
  ButtonAlternative,
  ButtonCreate,
} from "../../styles-components/Buttons";
import TablePagination from "../../components/TablePagination";
import { BsFillTrashFill, BsPencilSquare, BsSearch } from "react-icons/bs";
import UseRedirectView from "../../utils/UseRedirectView";
import { toast } from "react-toastify";
import ModalAtis from "../../components/ModalAtis";
import { useRef } from "react";
import { ListHeader } from "./styles";

const ListOrders = () => {
  const [month, setMonths] = useState(format(new Date(), "MM"));
  const [year, setYear] = useState(getYear(new Date()));
  const [services, setServices] = useState("TODOS");
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [listingType, setListingType] = useState("m");
  const [keys, setKeys] = useState([]);
  const [show, setShow] = useState(false);
  const [orderShow, setOrderShow] = useState("");
  const refOpenYear = useRef(null);
  const refOpenMonth = useRef(null);
  const refOpenServices = useRef(null);
  const refOpenCadastrar = useRef(null);

  const months = [
    { value: 1, name: "JANEIRO" },
    { value: 2, name: "FEVEREIRO" },
    { value: 3, name: "MARÇO" },
    { value: 4, name: "ABRIL" },
    { value: 5, name: "MAIO" },
    { value: 6, name: "JUNHO" },
    { value: 7, name: "JULHO" },
    { value: 8, name: "AGOSTO" },
    { value: 9, name: "SETEMBRO" },
    { value: 10, name: "OUTUBRO" },
    { value: 11, name: "NOVEMBRO" },
    { value: 12, name: "DEZEMBRO" },
  ];

  const services_type = [
    { value: "TODOS" },
    { value: "CAFÉ DA MANHÃ" },
    { value: "CAFÉ LITRO" },
    { value: "ALMOÇO" },
    { value: "JANTAR" },
    { value: "CEIA" },
    { value: "COFFEE BREAK" },
    { value: "LANCHE" },
    { value: "REFEIÇÕES" },
    { value: "REFRIGERANTE LATA" },
  ];

  const years = [
    { value: getYear(subYears(new Date(), 1)) },
    { value: getYear(new Date()) },
    { value: getYear(addYears(new Date(), 1)) },
  ];

  const fetchOrders = async (m, y, s) => {
    if (refOpenMonth.current) {
      refOpenMonth.current.checked = false;
    }
    if (refOpenYear.current) {
      refOpenYear.current.checked = false;
    }
    if (refOpenServices.current) {
      refOpenServices.current.checked = false;
    }
    if (refOpenCadastrar.current) {
      refOpenCadastrar.current.checked = false;
    }
    await apiPedidos.listOrders(m, y, s).then((response) => {
      setOrders(response.data.data);
      if (
        response.data.data !== null &&
        response.data.data !== undefined &&
        response.data.data !== "undefined"
      ) {
        setKeys(Object.keys(response.data.data));
      }
    });
  };

  useEffect(() => {
    setIsLoading(true);
    fetchOrders(month, year, services);
    setIsLoading(false);
  }, [month, year, services]);

  const onDestroy = async (id) => {
    if (confirm("Deseja realmente excluir este pedido???")) {
      try {
        await apiPedidos.destroy(id);
        fetchOrders(month, year, services);
        toast.success("Pedido excluído com sucesso!");
      } catch (error) {
        toast.error();
      }
    }
  };

  const handleOpenModal = (id, service) => {
    setShow(true);
    setOrderShow(orders[service].find((element) => element.id === id));
  };

  const handleQuantityOrder = (order) => {
    if (
      Object.values(order.quantity_order).length === 2 &&
      [6, 26, 12, 27, 17, 28].find((id) => id == order.service_id) != undefined
    ) {
      if (order.quantity_order[0].characteristic_id === 27) {
        return order.quantity_order[0].quantity;
      } else if (order.quantity_order[1].characteristic_id === 27) {
        return order.quantity_order[1].quantity;
      }
    } else {
      return order.quantity_order[0].quantity;
    }
  };

  useEffect(() => {
    if (!show) {
      setOrderShow("");
    }
  }, [show]);

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <>
          <ModalAtis onClose={() => setShow(false)} show={show}>
            {orderShow !== "" ? (
              <div style={{ padding: "20px" }}>
                <p>
                  <b>SERVIÇO: </b>
                  {orderShow.service.nome}
                </p>
                <p>
                  <b>DATA:</b> {orderShow.date}
                </p>

                {Object.keys(orderShow.quantity_order).length === 2 &&
                  orderShow.service_id === 2 && (
                    <>
                      <p>
                        <b>TOTAL: </b> {orderShow.quantity_order[0].quantity}
                      </p>
                    </>
                  )}

                {orderShow.quantity_order.length === 2 && (
                  <>
                    <p>
                      <b>TOTAL: </b>
                      {orderShow.quantity_order[0].characteristic_id === 6
                        ? orderShow.quantity_order[0].quantity
                        : orderShow.quantity_order[1].quantity}
                    </p>
                    <p>
                      <b>TOTAL COM %: </b>
                      {orderShow.quantity_order[0].characteristic_id === 27
                        ? orderShow.quantity_order[0].quantity
                        : orderShow.quantity_order[1].quantity}
                    </p>
                  </>
                )}

                {orderShow.quantity_order.length === 1 && (
                  <>
                    <p>
                      <b>TOTAL: </b> {orderShow.quantity_order[0].quantity}
                    </p>
                  </>
                )}

                {orderShow.time && (
                  <p>
                    <b>Horário: </b>
                    {orderShow.time.slice(_, 5).split(":").join("h")}
                  </p>
                )}

                {orderShow.place && (
                  <p>
                    <b>Local: </b>
                    {orderShow.place}
                  </p>
                )}

                {orderShow.tablecloth === 1 && (
                  <p>
                    <b>Este COFFEE solicitou toalha de mesa</b>
                  </p>
                )}

                {orderShow.glass === 1 && (
                  <p>
                    <b>Este COFFEE solicitou copo de vidro</b>
                  </p>
                )}

                <hr />
                {orderShow.quantity_cost_centers.length > 0 && (
                  <p>
                    <b>CENTROS DE CUSTO</b>
                  </p>
                )}
                {orderShow.quantity_cost_centers.length > 0 &&
                  orderShow.quantity_cost_centers.map((costCenter) => (
                    <React.Fragment key={costCenter.id}>
                      <pre>
                        <b>{costCenter.cost_center.name} </b>TOTAL:{" "}
                        {costCenter.quantity}
                        {costCenter.quantity_percentage != null ? (
                          <>
                            {" | "}
                            TOTAL COM %: {costCenter.quantity_percentage}
                          </>
                        ) : (
                          ""
                        )}
                      </pre>
                    </React.Fragment>
                  ))}
                <hr />

                <p>
                  <b>OBS:</b> {orderShow.note}
                </p>
              </div>
            ) : (
              ""
            )}
          </ModalAtis>
          <div>
            <Dropdown>
              <DropdownButton>
                <label htmlFor="openMonth">
                  {`${format(setMonth(new Date(), month - 1), "MMMM", {
                    locale: ptBR,
                  })}`}{" "}
                  <span>▼</span>
                </label>
              </DropdownButton>
              <input type="checkbox" id="openMonth" ref={refOpenMonth} />
              <DropdownContent>
                {months.map((m) => (
                  <DropdownItem
                    key={m.value}
                    onClick={() => setMonths(m.value)}
                  >
                    {m.name}
                  </DropdownItem>
                ))}
              </DropdownContent>
            </Dropdown>
            {/* <a>{`${getYear(subYears(new Date(), 1))}`}</a> */}
            <Dropdown>
              <DropdownButton>
                <label htmlFor="openYear">
                  {year} <span>▼</span>
                </label>
              </DropdownButton>
              <input type="checkbox" id="openYear" ref={refOpenYear} />
              <DropdownContent>
                {years.map((y) => (
                  <DropdownItem key={y.value} onClick={() => setYear(y.value)}>
                    {y.value}
                  </DropdownItem>
                ))}
              </DropdownContent>
            </Dropdown>
            <Dropdown>
              <DropdownButton>
                <label htmlFor="openServices">
                  {services} <span>▼</span>
                </label>
              </DropdownButton>
              <input type="checkbox" id="openServices" ref={refOpenServices} />
              <DropdownContent>
                {services_type.map((s) => (
                  <DropdownItem
                    key={s.value}
                    onClick={() => setServices(s.value)}
                  >
                    {s.value}
                  </DropdownItem>
                ))}
              </DropdownContent>
            </Dropdown>
          </div>

          <ListHeader>
            <div>
              <ButtonAlternative
                href="#mes"
                id="mes"
                onClick={() => setListingType("m")}
              >
                MÊS
              </ButtonAlternative>
              <span>|</span>
              <ButtonAlternative
                href="#quinzena"
                id="quinzena"
                onClick={() => setListingType("q")}
              >
                QUINZENA
              </ButtonAlternative>
            </div>
            <ButtonCreate color="--orange" as={"div"} isDrop>
              <Dropdown style={{ margin: "0 0 0 0" }} isButton>
                <DropdownButton inDrop>
                  <label htmlFor="openCadastrar">CADASTRAR</label>
                </DropdownButton>
                <input
                  type="checkbox"
                  id="openCadastrar"
                  ref={refOpenCadastrar}
                />
                <DropdownContent>
                  <DropdownItem
                    onClick={() =>
                      UseRedirectView.to(`formulario/pedidos/create`)
                    }
                  >
                    CADASTRAR PEDIDO
                  </DropdownItem>
                  <DropdownItem
                    onClick={() =>
                      UseRedirectView.to(`formulario/lanches/create`)
                    }
                  >
                    CADASTRAR LANCHE / COFFEE
                  </DropdownItem>
                </DropdownContent>
              </Dropdown>
            </ButtonCreate>
          </ListHeader>

          <ContainerCard>
            {listingType == "m"
              ? keys.map((service, index) => {
                  return (
                    orders[service] &&
                    orders[service].length > 0 && (
                      <Table key={index} type={listingType}>
                        <thead>
                          <tr>
                            <th colSpan={4}>{service}</th>
                          </tr>
                          <tr>
                            <th>DATA</th>
                            <th>TOTAL</th>
                            <th>OBSERVAÇÕES</th>
                            <th>AÇÕES</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders[service].map((order) => (
                            <tr key={order.id}>
                              <td>{order.date}</td>
                              <td>{handleQuantityOrder(order)}</td>
                              <td>{order.note}</td>
                              <td>
                                <ButtonA
                                  as={"button"}
                                  style={{ margin: "5px" }}
                                  color="--white"
                                  backgroundColor="--blue-icon"
                                  onClick={() =>
                                    handleOpenModal(order.id, service)
                                  }
                                >
                                  <BsSearch />
                                </ButtonA>
                                {order.service_id == 47 ? (
                                  <>
                                    {order.canBeDeleted && (
                                      <ButtonA
                                        as={"button"}
                                        style={{ margin: "5px" }}
                                        color="--white"
                                        backgroundColor="--red"
                                        onClick={() => {
                                          console.log("🤡");
                                          onDestroy(order.id);
                                        }}
                                      >
                                        <BsFillTrashFill />
                                      </ButtonA>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {order.canBeDeleted && (
                                      <>
                                        {[
                                          30, 31, 32, 33, 34, 35, 36, 37, 38,
                                          39, 40, 57, 58, 59, 60, 61, 62, 72,
                                        ].find(
                                          (id) => id == order.service_id
                                        ) == undefined && (
                                          <ButtonA
                                            as={"button"}
                                            color="--white"
                                            backgroundColor="--yellow"
                                            onClick={() => {
                                              console.log("😎");
                                              UseRedirectView.to(
                                                `formulario/pedidos/${order.id}/edit`
                                              );
                                            }}
                                          >
                                            <BsPencilSquare />
                                          </ButtonA>
                                        )}
                                        <ButtonA
                                          as={"button"}
                                          style={{ margin: "5px" }}
                                          color="--white"
                                          backgroundColor="--red"
                                          onClick={() => {
                                            console.log("🤡");
                                            onDestroy(order.id);
                                          }}
                                        >
                                          <BsFillTrashFill />
                                        </ButtonA>
                                      </>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )
                  );
                })
              : keys.map((service, index) => {
                  return (
                    orders[service] &&
                    orders[service].length > 0 && (
                      <TablePagination
                        key={index}
                        orders={orders[service]}
                        service={service}
                        type={listingType}
                        onDestroy={onDestroy}
                        handleOpenModal={handleOpenModal}
                        handleQuantityOrder={handleQuantityOrder}
                        user="client"
                      />
                    )
                  );
                })}
          </ContainerCard>
        </>
      )}
    </>
  );
};

export default ListOrders;
